import { Component, Input, OnInit, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DropdownOption } from '@app/storybook/components/dropdown/dropdown.component';
import { MultiShipmentExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { BANNER_STYLE_OPTIONS, SectionBannerForm } from '../../model';

@Component({
  selector: 'multi-shipment-section-banner',
  templateUrl: './section-banner.component.html',
  styleUrls: ['./section-banner.component.scss'],
  standalone: false,
})
export class SectionBannerComponent implements OnInit {
  @Input({ required: true }) formGroup!: FormGroup<SectionBannerForm>;
  @Input({ required: true }) sectionId!: string;
  @Input({ required: true }) title!: string;
  @Input() subtitle?: string;
  @Input() placeholder?: string;

  readonly styleOptions: DropdownOption[] = [...BANNER_STYLE_OPTIONS];
  readonly selectedStyleOption = signal<DropdownOption>(this.styleOptions[0]);

  ngOnInit(): void {
    const style = this.formGroup.controls.style.value;
    this.selectedStyleOption.set(this.styleOptions.find((option) => option.value === style) ?? this.styleOptions[0]);
  }

  onBannerTextChange(content: string): void {
    this.formGroup.controls.text.setValue(content);
    this.formGroup.controls.text.markAsDirty();
  }

  onStyleChange(option: DropdownOption): void {
    this.selectedStyleOption.set(option);
    this.formGroup.controls.style.setValue(option.value as MultiShipmentExtension.BannerStyle);
    this.formGroup.controls.style.markAsDirty();
  }
}
